export const LANDING = {
  // Header
  header: 'landing-header',
  logo: 'landing-logo',
  navAbout: 'landing-nav-about',
  navSupport: 'landing-nav-support',
  navResources: 'landing-nav-resources',
  navGetInvolved: 'landing-nav-get-involved',
  navStories: 'landing-nav-stories',
  navEvents: 'landing-nav-events',
  searchButton: 'landing-search-button',
  loginButton: 'landing-login-button',
  donateButton: 'landing-donate-button',

  // Hero
  heroEyebrow: 'landing-hero-eyebrow',
  heroHeadline: 'landing-hero-headline',
  heroSupporting: 'landing-hero-supporting',
  heroBody: 'landing-hero-body',
  heroPrimaryCta: 'landing-hero-primary-cta',
  heroSecondaryCta: 'landing-hero-secondary-cta',
  heroImage: 'landing-hero-image',
  heroFloatingCard: 'landing-hero-floating-card',

  // Mission strip
  mission: 'landing-mission-strip',
  missionConnect: 'landing-mission-connect',
  missionSupport: 'landing-mission-support',
  missionWalk: 'landing-mission-walk',
  missionHere: 'landing-mission-here',

  // Impact stats
  impact: 'landing-impact-section',
  impactStat: 'landing-impact-stat',
  impactTestimonial: 'landing-impact-testimonial',

  // Trust bar
  trustBar: 'landing-trust-bar',

  // Ecosystem grid
  ecosystem: 'landing-ecosystem-grid',
  ecosystemCard: 'landing-ecosystem-card',

  // Portal preview
  portalPreview: 'landing-portal-preview',
  portalPreviewTab: 'landing-portal-preview-tab',

  // Testimonials
  testimonialsCarousel: 'landing-testimonials-carousel',
  testimonialsPrev: 'landing-testimonials-prev',
  testimonialsNext: 'landing-testimonials-next',

  // Final CTA
  finalCta: 'landing-final-cta',
  finalCtaJoin: 'landing-final-cta-join',
  finalCtaExplore: 'landing-final-cta-explore',

  // Footer
  footer: 'landing-footer',
  newsletterInput: 'landing-newsletter-input',
  newsletterButton: 'landing-newsletter-button',
};

export const PORTAL = {
  layout: 'portal-layout',
  sidebar: 'portal-sidebar',
  navDashboard: 'portal-nav-dashboard',
  navMessaging: 'portal-nav-messaging',
  navCommunity: 'portal-nav-community',
  navVolunteer: 'portal-nav-volunteer',
  navHospital: 'portal-nav-hospital',
  navResources: 'portal-nav-resources',
  navEvents: 'portal-nav-events',
  navSupport: 'portal-nav-support',
  navProfile: 'portal-nav-profile',
  logoutButton: 'portal-logout-button',
};

export const FORMS = {
  supportForm: 'forms-support-form',
  supportName: 'forms-support-name',
  supportEmail: 'forms-support-email',
  supportPhone: 'forms-support-phone',
  supportMessage: 'forms-support-message',
  supportSubmit: 'forms-support-submit',
  volunteerForm: 'forms-volunteer-form',
  hospitalForm: 'forms-hospital-form',
  contactForm: 'forms-contact-form',
};
